export default function BookIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 5.625C9.5625 3.40454 11.687 2.27075 16.3125 2.25C16.3865 2.24973 16.4597 2.26408 16.5281 2.29225C16.5965 2.32042 16.6586 2.36185 16.7109 2.41413C16.7632 2.46642 16.8046 2.52854 16.8328 2.59692C16.8609 2.66529 16.8753 2.73856 16.875 2.8125V12.9375C16.875 13.0867 16.8157 13.2298 16.7103 13.3353C16.6048 13.4407 16.4617 13.5 16.3125 13.5C11.8125 13.5 10.074 14.4074 9 15.75M9 5.625C8.4375 3.40454 6.31301 2.27075 1.6875 2.25C1.61356 2.24973 1.54029 2.26408 1.47192 2.29225C1.40354 2.32042 1.34142 2.36185 1.28913 2.41413C1.23685 2.46642 1.19542 2.52854 1.16725 2.59692C1.13908 2.66529 1.12473 2.73856 1.125 2.8125V12.8697C1.125 13.217 1.34016 13.5 1.6875 13.5C6.1875 13.5 7.93231 14.4141 9 15.75M9 5.625V15.75"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
